import type { FC } from "react";
import { Select } from "../../components/select/Select";
import { useCustomerContacts } from "./useCustomerContacts";

interface Props {
  readonly customerId: string;
  readonly contactPersonEmail: string | null;
  readonly onChange: (contactPersonEmail: string | null) => void;
  readonly size?: "small" | "medium";
}

const ContactPersonSelect: FC<Props> = ({ customerId, contactPersonEmail, onChange, size }) => {
  const { contacts } = useCustomerContacts(customerId);
  return (
    <Select
      label="Osoba kontaktowa"
      value={contactPersonEmail ?? ""}
      values={contacts.map((c) => ({ value: c.loginEmail ?? c.email ?? "", label: c.name }))}
      fullWidth
      size={size}
      onSelect={onChange}
    />
  );
};

export default ContactPersonSelect;
